import React, { Component } from 'react';
import { View, Button, PageContainer, Card, Loc } from '../UIElements/All.js';
import { Colors, ButtonColors } from '../Managers/ThemeManager';

import { backToScan, close } from '../Managers/LSLoyaltyAPI';
import { pop, push } from '../Managers/AppActions';
var LocalizationManager = require('../Managers/LocalizationManager.js');

export default class CustomerOptions extends Component 
{
  constructor(props) 
  {
    super(props);

	var state = this.props.location.state;
	this.state = state;
  }

  componentDidMount()
  {
  }

  componentWillUnmount()
  {
  }

  render() 
  {
	var self = this;

    return (
	  	<PageContainer urlInputs={this.state.urlInputs} ref={(a) => { this._pageContainer = a; }}>
	  		<Card style={{position:'relative', textAlign:'center', alignItems:'center', justifyContent:'center', alignSelf:'stretch', flex:-1, height:220, backgroundColor:Colors.background2, borderRadius:4, flexDirection:'column', color:Colors.text1, fontSize:24, alignItems:'center', justifyContent:'center', padding:12, margin:12}}>
	  			<View style={{flex: 1}} />
	      	 	<View style={{flex:-1, margin:8, textAlign:'center', alignItems:'center', fontWeight:'bold', justifyContent:'center'}}>
					<Loc locKey={this.state.title}></Loc> 
	      	 	</View>
	      	 	<View style={{flex:-1, fontSize:18, textAlign:'center', alignItems:'center', justifyContent:'center'}}>
				   	<Loc locKey={this.state.body}></Loc>
	      	 	</View>
	      	 	<View style={{flex: 1}} />

		      	{ 
		      		!this.state.closeButtonOnly ? 
			      		<Button onPress={()=>
				  		{
				  			backToScan();
				  			push(self, "Splash")
				  		}} type={0} colors={ButtonColors} style={{alignSelf:'stretch', margin:12}}>
						  { typeof this.state.scanButtonTitle === 'undefined' ? 
						  	<Loc locKey="SCAN_AGAIN_BUTTON"></Loc>  : this.state.scanButtonTitle }
				      	</Button>
		      		: null
		      	}
		      	{
		      		typeof this.props.urlInputs !== 'undefined' ?
		      			<Button onPress={()=> close(self.state.urlInputs)} type={1} colors={ButtonColors} style={{alignSelf:'center', margin:12}}>
							  { typeof this.state.closeButtonTitle === 'undefined' ? 
							  	<Loc locKey="BACK_TO_PAY_BUTTON"></Loc> : this.state.closeButtonTitle }
			      		</Button>
		      		: null
		      	}
	      	 	<View style={{flex: 1}} />
	      	</Card>
	  	</PageContainer>
    );
  }
}

CustomerOptions.defaultProps = {
	showCollectPoints: false
}
